export const setHookPosition = (self, { x, y }) => {
  const hook_g_el = self._getHookGElThrowable();
  hook_g_el.setAttributeNS(null, "transform", `translate(${x} ${y})`);
};
